function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.002,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.34 45.535c12.274 0 22.224-9.95 22.224-22.224 0-12.274-9.95-22.224-22.224-22.224-12.274 0-22.224 9.95-22.224 22.224 0 12.274 9.95 22.224 22.224 22.224z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.162 21.669l6.178 6.077 6.177-6.077m-6.177 5.759v-14.34m-6.178 18.574h12.355"
}));

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 47"
  }, props), _ref);
}

export default "/krr/images/download.svg";
export { SvgDownload as ReactComponent };